import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { Boondock, Listing } from '@curbnturf/entities';

@Component({
  selector: 'curbnturf-weather-widget',
  templateUrl: './weather-widget.component.html',
  styleUrls: ['./weather-widget.component.scss'],
  standalone: true,
})
export class WeatherWidgetComponent implements OnInit {
  @Input() listing: Listing | Boondock;

  constructor(
    private hostEl: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {}
  ngOnInit() {
    if (!this.listing || !this.listing.coordinates) {
      return;
    }

    if (this.document && !isPlatformServer(this.platformId)) {
      const scriptTag = this.document.createElement('script');
      scriptTag.type = 'text/javascript';
      scriptTag.src = `https://darksky.net/widget/default/${this.listing.coordinates.lat},${
        this.listing.coordinates.lon
      }/us12/en.js?width=100%&height=320&title=${this.listing.displayLocation()}&textColor=454545&bgColor=FFFFFF&transparency=false&skyColor=undefined&fontFamily=Sans-Serif&customFont=&units=us&htColor=454545&ltColor=C7C7C7&displaySum=yes&displayHeader=yes`;
      this.hostEl.nativeElement.appendChild(scriptTag);
    }
  }
}
